import React from 'react'
import { DefaultLayout } from '../../layouts'
import { RelatedResources, TypeBook, TypeVideo, TypeFile, TypeExpert } from './components'
import { useLocation } from 'react-router-dom'
import { SimplePageHeader } from '../../components'
import { normalizer } from '../../utils'
import rawData from '../../database/resources.json'

const normalized = normalizer(rawData)

const ResourceDetail = (props) => {
  const location = useLocation()
  const { match } = props
  const data = normalized[match.params.id]

  return (
    <DefaultLayout>
      <SimplePageHeader noPadding/>
      {
        data.type === 'file' &&
        <TypeFile data={data}/>
      }
      {
        location.pathname.includes('video') &&
        <TypeVideo data={data}/>
      }
      {
        location.pathname.includes('book') &&
        <TypeBook data={data}/>
      }
      {
        location.pathname.includes('file') &&
        <TypeFile data={data}/>
      }
      {
        (location.pathname.includes('expert') || data.type === 'expert') &&
        <div>
          <TypeExpert data={data}/>
          <RelatedResources type="expert"/>
        </div>
      }
      {
        location.pathname === '/resource/detail' &&
        <TypeFile />
      }
      {
        data.type !== 'expert' &&
        <RelatedResources />
      }
    </DefaultLayout>
  )
}

export { ResourceDetail }